module.exports = __webpack_public_path__ + "static/media/bg.6a8a7a30.jpeg";